<template>
  <el-dialog
    title="已关联商品批次"
    :visible.sync="visible"
    width="45%"
    :close-on-press-escape="false">
    <el-table
      ref="table"
      v-loading="loading"
      border
      row-key="batchId"
      :data="row.batchs">
      <el-table-column
        label="商品批次号"
        width="140"
        prop="batchCode">
      </el-table-column>
      <el-table-column
        label="商品名称"
        prop="productName">
      </el-table-column>
      <el-table-column
        label="商品数量"
        width="100"
        prop="goodsCount">
      </el-table-column>
      <el-table-column
        label="创建时间"
        width="100">
        <template slot-scope="scope">
          {{ scope.row.createdTime | dateformat('YYYY-MM-DD') }}
        </template>
      </el-table-column>
    </el-table>
    <span slot="footer">
      <el-button
        v-if="enable"
        type="primary"
        @click="associate">选择批次</el-button>
      <el-button
        :loading="loading"
        @click="toggleModal(false)">关闭</el-button>
      <!-- <el-button type="primary"
        @click="submit"
        :loading="loading">确定</el-button> -->
    </span>
    <associate-batch-modal
      ref="modal"
      :selected="row.batchs"
      :option="{tradeType: tradeType, vendorId: vendorId, productIds: productIds}"
      @update:selection="handleSelectionChange" />
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
import clonedeep from 'lodash.clonedeep'
import AssociateBatchModal from './associate-batch-modal.vue'
export default {
  name: 'AssociateProductBatchModal',
  components: { AssociateBatchModal },
  props: {
    tradeType: [Number, String],
    vendorId: [Number, String]
  },
  data() {
    return {
      visible: false,
      loading: false,
      productIds: [],
      index: -1,
      row: {
        batchs: []
      },
      inspect: {}
    }
  },
  computed: {
    ...mapState({
      userPermission: state => state.account.permission
    }),
    enable() {
      return (this.$route.path === '/inspect-detail' && this.inspect.status === 3 && this.userPermission.ENT) || this.$route.path === '/inspect-update' || this.$route.path === '/inspect-create'
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleSelectionChange(rows) {
      console.log(rows)
      this.row.batchs = rows
      this.$emit('update:selection', this.index, this.row)
    },
    associate() {
      this.$refs.modal.toggleModal(true)
    },
    fetch(index, row, inspect) {
      console.log(index, row, inspect)
      this.row = {
        ...this.row,
        ...row,
        batchs: row.batchs || []
      }
      this.index = index
      this.productIds = [row.productId]
      this.inspect = clonedeep(inspect)
      this.toggleModal(true)
    }
  }
}
</script>
